import React, { useContext } from 'react';
import classNames from 'classnames';
import ResolvePopup from 'components/ResolvePopup';
import { Button } from 'ncoded-component-library';
import { useTranslation } from 'react-i18next';
import LinkIcon from 'icons/Link.icon';
import {
  DATA_ROOM_SHAREABLE_LINK_ACCESS,
  DataRoomShareableLink,
} from 'models/ShareableLink';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import CreateShareableLinkContext from 'router/subrouters/DataRoom/providers/CreateShareableLink/CreateShareableLink.context';

import './CreateNewSecureLinkButton.styles.scss';

type CreateNewSecureLinkButtonProps = {
  className?: string;
  dataRoomShareableLinkRequestId: string;
  dataRoomShareableLink: DataRoomShareableLink;
  email: string;
};

const CreateNewSecureLinkButton: React.FC<CreateNewSecureLinkButtonProps> = (
  props,
) => {
  const {
    className,
    dataRoomShareableLinkRequestId,
    dataRoomShareableLink,
    email,
  } = props;

  const { doesntHaveAccess } = useContext(DataRoomContext);
  const { openCreateShareableLinkWithTemplate } = useContext(
    CreateShareableLinkContext,
  );

  const classes = classNames('create-new-secure-link-button', className);

  const { t } = useTranslation();

  return (
    <ResolvePopup onHover popupContent={t('createNew')} className={classes}>
      <Button
        variant="icon"
        disabled={doesntHaveAccess}
        icon={LinkIcon}
        onClick={() => {
          if (doesntHaveAccess) return;

          openCreateShareableLinkWithTemplate({
            ...dataRoomShareableLink,
            dataRoomShareableLinkRequestId,
            linkAccess: DATA_ROOM_SHAREABLE_LINK_ACCESS.SPECIFIC_RECIPIENTS,
            recipientEmailAddresses: [email],
          });
        }}
      />
    </ResolvePopup>
  );
};

export default CreateNewSecureLinkButton;
